export default __webpack_public_path__ + "static/typography-image-h-0554968e3122f1d4ee45751a07fb53dda7ff0bb6e570958c5dfbae08c5dc060a.png";